// Секретарь (deus_sekretar, common):
// passive: ВСЕ удары по Герою владельца перенаправляются на этого юнита.
//   — Реализация: hero-damage.js + priorities.js (для авто-атак).
// EOT-trigger: если HP этого юнита > HP Героя владельца → +0/1/1 (постоянный, может превышать base).

export const CARD_ID = 'deus_sekretar';

export function sekretarEot(state, ownerIdx, card) {
  const p = state.players[ownerIdx];
  if (!p || !card.isAlive()) return;
  if (card.hp > p.hero.hp) {
    card.persistentArmor += 1;
    card.persistentMaxArmor += 1;
    card.current.armor += 1;
    card.current.hp += 1;
    state.log.add(`📋 Секретарь [${p.name}]: HP > HP Героя → +0/1/1 (HP=${card.hp}, броня=${card.armor})`);
  }
}
